module.exports = __webpack_public_path__ + "static/img/NZ@2x.115972e5.jpg";